import React from "react";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Company } from "../../../types/inventoryAdjustments";

import styles from "../InventoryAdjustmentsDetails.module.scss";

interface Props {
  ownerCompany: Company;
  createdBy: string;
  completedDate: string;
}

const InventoryAdjustmentDetailsLocationSection = ({
  completedDate,
  ownerCompany,
  createdBy,
}: Props) => {
  const { t } = useTranslation();

  const renderEvent = (titleKey: string, dateString: string) => {
    const date = new Date(dateString);

    return (
      <div key={titleKey} className={styles.dateItem}>
        <span>{t(`transfers.details.eventTitles.${titleKey}`)}</span>
        <span className={styles.dateLine}>{format(date, "MMM d, yyyy")}</span>
        <span className={styles.timeline}>{format(date, "h:mm a")}</span>
      </div>
    );
  };

  return (
    <div className={styles.locationSectionDataWrapper}>
      <div className={styles.locationSectionActionContainer}>
        <div className={styles.locationSectionDataContainer}>
          <div className={styles.locationSectionHeader}>
            <h2>{t(`inventoryAdjustment.details.header`)}</h2>
          </div>
          <div className={styles.dateDeliveryWrapper}>
            <div className={styles.participantInfo}>
              <div className={styles.participantRoleInfo}>
                <span>
                  {`${t(`businessRoles.${ownerCompany?.businessRoleCode}`)} · `}
                </span>
                <Link to={`/participants/${ownerCompany?.companyId}`}>
                  {`#${ownerCompany?.regNumber}`}
                </Link>
              </div>
              <div className={styles.participantResponsibleInfo}>
                <span>{ownerCompany?.displayName}</span>
                <span>
                  {`${t("inventoryAdjustment.details.responsibleFor.by", {
                    createdBy,
                  })} `}
                </span>
              </div>
            </div>
            <div>
              {completedDate && renderEvent("Completed", completedDate)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InventoryAdjustmentDetailsLocationSection;
